import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import sectionGreenBg from '../../assets/images/section-green.webp';
import wrapCenterBg from '../../assets/images/wrap-center.webp';

import { Mailto, SanitizedHTML } from '../../utils/Helper';
import Skeleton from '../../components/skeleton/Skeleton';
import { usePageContent } from '../../hooks/usePageContent';

const PageContent = ({ page }) => {
    const { content, isLoading, error } = usePageContent( page?.id );

    if ( !page?.id || ( !content.id && !isLoading ) ) return null;

    return (
        <section id="about" className="about-page section" style={{ backgroundImage: `url(${wrapCenterBg})` }}>
            <div
                className="section-decoration top"
                style={{ backgroundImage: `url(${sectionGreenBg})`, height: '35px' }}
            />
            <Container>
                {isLoading ? (
                    <Skeleton type="about" />
                ) : (
                <>
                    <Row>
                        <Col lg={8} className="text-center text-lg-start wow fadeInUp">
                            <SanitizedHTML className="text-3" html={content.content} tag="div" />
                        </Col>
                        <Col lg={4} className="mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="featured-box style-4">
                                <div className="featured-box-icon text-25 fw-500 bg-secondary rounded-circle">
                                    <span className="wow heartBeat" data-wow-delay="1.3s">
                                    {content.years_of_experience}
                                    </span>
                                </div>
                                <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                                    Years of <span className="fw-700 text-dark">Experience</span>
                                </h3>
                            </div>
                        </Col>
                    </Row>

                    <Row className="gy-3 mt-4">
                    {[
                        { label: 'Phone', value: content.phone_number },
                        {
                        label: 'Email',
                        value: (
                            <Mailto
                            email={content.email_address}
                            subject="Hello"
                            body="Hello Jinesh P.V"
                            >
                            {content.email_address}
                            </Mailto>
                        ),
                        },
                        { label: 'Date of birth', value: content.date_of_birth },
                        { label: 'From', value: content.place },
                    ].map((item, idx) => (
                        <Col key={item.label} lg={3} sm={6} xs={12} className="wow fadeInUp" data-wow-delay={`${idx * 0.1}s`}>
                            <p className="text-muted fw-500 mb-0">{item.label}:</p>
                            <p className="text-3 text-dark fw-600 mb-0">{item.value}</p>
                        </Col>
                    ))}
                    </Row>
                </>
                )}
                {error && (
                    <div className="text-danger mt-4">
                        <strong>Error:</strong> {error}
                    </div>
                )}
            </Container>
        </section>
    );
};

export default PageContent;